import React from 'react'
import { func } from 'prop-types'
import { connect } from 'react-redux'

import { magicEraserTutorialSeen } from 'models/user/actions'
import MagicEraserTutorial from 'components/design/MagicEraserTutorial'

const MagicEraserTutorialContainer = ({ onSeen }) => <MagicEraserTutorial onSeen={onSeen} />

MagicEraserTutorialContainer.propTypes = {
    onSeen: func.isRequired,
}

const mapDispatchToProps = {
    onSeen: magicEraserTutorialSeen,
}

export default connect(null, mapDispatchToProps)(MagicEraserTutorialContainer)
